import { render, staticRenderFns } from "./application.vue?vue&type=template&id=1f486013&scoped=true"
import script from "./application.vue?vue&type=script&lang=js"
export * from "./application.vue?vue&type=script&lang=js"
import style0 from "./application.vue?vue&type=style&index=0&id=1f486013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f486013",
  null
  
)

export default component.exports